import DialogConfirmar from '@/global/guides/Dialog/DialogConfirmar'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { campanhas } from 'service/api'
import { toast } from 'sonner'

export default function EncerrarCampanha() {
    const { id } = useParams()
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    const { mutate, isLoading } = useMutation(
        () => campanhas.post(`${id}/encerrar`, {} as never),
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries(campanhas.queryKey())
                toast.success('Campanha encerrada')
                navigate(-1)
            },
            onError: (e: Error) => {
                toast.error(e.message)
            },
        },
    )

    return (
        <DialogConfirmar
            permissao={['update', 'Notificações']}
            loading={isLoading}
            title="Encerrar campanha"
            fecharAoConfirmar={false}
            onConfirm={() => mutate()}
        >
            A campanha deixa de ser entregue imediatamente. Quem já recebeu
            continua vendo o que estiver aberto na tela.
        </DialogConfirmar>
    )
}
